export const ThemeStorage = {
    save: (theme: string, username: string) => {
        if (!username) return;
        const userThemes = ThemeStorage.getAllUserThemes();
        userThemes[username] = theme;
        localStorage.setItem('userThemes', JSON.stringify(userThemes));
    },
    load: (username: string): string => {
        if (!username) return 'light';

        const userThemes = ThemeStorage.getAllUserThemes();
        return userThemes[username] || 'light';
    },
    getAllUserThemes: (): Record<string, string> => {
        try {
            const stored = localStorage.getItem('userThemes');
            return stored ? JSON.parse(stored) : {};
        } catch {
            return {};
        }
    }
};